import _get from 'lodash/get';
import _castArray from 'lodash/castArray';

import { Base, Address } from '@/models';
import { toCamelCase, omitDeep } from '@/utilities';
export class Contractor extends Base {

  public id: string;
  public companyName: string;
  public email: string;
  public phone: string;
  public address: Address;


  /**
   * Constructor initialises the variables from the class Contractor
   * @param data - the data to construct a type with all properties of <Contractor>
   */
  public constructor(data?: Partial<Contractor>) {
    super(data);
    data = toCamelCase(data);

    this.id = _get(data, 'id', '');
    this.companyName = _get(data, 'companyName', '');
    this.email = _get(data, 'email', '');
    this.phone = _get(data, 'phone', '');
    this.address = new Address(_get(data, 'address'));
  }

  /**
   * Convert class instance back into a plain old JSON object
   * and recursively remove all uuids we've add for Vue.
   *
   * @return {Object}
   */
  public toObject() {
    return omitDeep({ ...this }, ['_uuid']);
  }

}
